import { Reducer } from 'redux'
import { LearningCoursesState, LearningCoursesTypes } from './types'

const INITIAL_STATE: LearningCoursesState = {
  data: [],
  error: false,
  status: 'idle',
}

const reducer: Reducer<LearningCoursesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LearningCoursesTypes.FETCH_COURSES_REQUEST:
      return { ...state, status: 'loading' }
    case LearningCoursesTypes.FETCH_COURSES_SUCCESS:
      return {
        ...state,
        error: false,
        data: action.payload.data,
        status: 'success',
      }
    case LearningCoursesTypes.FETCH_COURSES_FAILURE:
      return {
        ...state,
        error: true,
        status: 'error',
      }
    case LearningCoursesTypes.CLEAR_COURSES:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
